import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Image from '../../components/Image';

const styles = theme => ({
  root: {
    position: 'fixed',
    bottom: '1rem',
    right: '1rem',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    padding: '10px 0',
    boxShadow: '5px 5px 14px 0 rgba(0,0,0,0.3)',
    zIndex: 3,
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  section: {
    padding: '1rem 10px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  }
});

class UserUtilityBar extends React.Component {
  state = {
    openCallUsDialog: false
  };

  handleDialogOpen = e => {
    this.setState({ openCallUsDialog: true });
  };

  handleDialogClose = e => {
    this.setState({ openCallUsDialog: false });
  };

  scrollToTop = e => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div onClick={this.handleDialogOpen} className={classes.section}>
          <Image src="/homepage/call.svg" />
        </div>
        <div onClick={this.scrollToTop} className={classes.section}>
          <Image src="/homepage/back to top.svg" />
        </div>
        <Dialog
          open={this.state.openCallUsDialog}
          onClose={this.handleDialogClose}
        >
          <DialogTitle>Call Us!</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To contact Customer Service call or click the number below.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose} variant="contained">
              Back
            </Button>
            <Button
              component="a"
              href="tel:+18447686945"
              variant="contained"
              color="primary"
            >
              (844) 768-6945
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(UserUtilityBar);
